import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import styles from './firmware-wizard-modal.css';

/**
 * StepIndicator — 3-pip horizontal step visualization for the Firmware OTA
 * Wizard (GEN-05). Pips with index <= currentStep render filled navy;
 * upcoming pips render gray. Lines between pips fill navy when the LEFT pip
 * is done (i.e. i < currentStep).
 *
 * Visual goal (per DG-15): "(1)—(2)—(3)" with current/done navy, future gray.
 *
 * @returns {React.ReactElement} step indicator element
 */
const StepIndicator = ({totalSteps, currentStep, labels}) => (
    <div className={styles.stepIndicator}>
        {Array(totalSteps).fill(0)
            .map((_, i) => (
                <React.Fragment key={`pip-${i}`}>
                    <div className={styles.pipBlock}>
                        <div
                            className={classNames(
                                styles.pip,
                                i <= currentStep ? styles.pipActive : styles.pipInactive
                            )}
                        >
                            {i + 1}
                        </div>
                        {labels && labels[i] ? (
                            <div className={styles.pipLabel}>{labels[i]}</div>
                        ) : null}
                    </div>
                    {i < totalSteps - 1 ? (
                        <div
                            className={classNames(
                                styles.pipLine,
                                i < currentStep ? styles.pipLineActive : null
                            )}
                        />
                    ) : null}
                </React.Fragment>
            ))}
    </div>
);

StepIndicator.propTypes = {
    currentStep: PropTypes.number.isRequired,
    labels: PropTypes.arrayOf(PropTypes.node),
    totalSteps: PropTypes.number.isRequired
};

export default StepIndicator;
